// extracted by mini-css-extract-plugin
export default {"disclaimer":"DoctorsGridDisclaimer_disclaimer__nW2wY"};